module.exports = __webpack_public_path__ + "img/camera-web-slash.bc90df75.svg";